// src/store/labelStore.ts

import { createApiStore, GenericStore } from "./genericStore";
import { LabelCategory, LabelTemplate, LabelVariantPayload } from "../types/label";
import api from "../service/api";

// 1. Label Store'a özel ek metotları tanımlayan Interface
interface LabelStore extends GenericStore<LabelTemplate> {
  getTemplateById: (id: string) => Promise<LabelTemplate>;
  saveVariant: (payload: LabelVariantPayload) => Promise<any>;

  // YENİ EKLENENLER
  getCategories: () => Promise<{ code: string; name: string }[]>;
  getVariablesByCategory: (category: LabelCategory) => Promise<any[]>;
  getSampleData: (category: LabelCategory) => Promise<any>;
  getPrinters: () => Promise<any[]>;
  getPreview: (payload: { templateId: number; printerId: number; data: any }) => Promise<string>;
}

// 2. Base Generic Store Oluşturma (/labels endpoint'ine bağlı)
export const useLabelStore = createApiStore<LabelTemplate>("/label") as unknown as () => LabelStore;

// 3. Mevcut store'a özel aksiyonları extend edelim (Extra Actions)
const useLabelStoreBase = useLabelStore as any;

useLabelStoreBase.setState((state: any) => ({
  ...state,

  /**
   * Şablon Detayını Getir
   */
  getTemplateById: async (id: string) => {
    try {
      useLabelStoreBase.setState({ loading: true, error: null });

      // API'den tek bir şablonun varyantlarıyla birlikte detayını çekiyoruz
      const res = await api.get(`/label/${id}`);

      useLabelStoreBase.setState({ loading: false });
      return res.data;
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || "Şablon detayları yüklenirken bir hata oluştu";
      useLabelStoreBase.setState({
        error: { message: errorMessage, details: err.response?.data?.details || null },
        loading: false
      });
      throw err;
    }
  },
  /**
   * Sistemdeki şablon kategorilerini (sistem kodlarını) getirir
   */
  getCategories: async () => {
    try {
      const res = await api.get("/label/categories");
      return res.data;
    } catch (err) {
      console.error("Kategoriler yüklenemedi", err);
      return [];
    }
  },

  /**
     * Kategoriye göre kullanılabilecek değişkenleri getirir
     */
  getVariablesByCategory: async (category: LabelCategory) => {
    try {
      const res = await api.get(`/label/variables/${category}`);
      return res.data;
    } catch (err) {
      console.error("Değişkenler yüklenemedi", err);
      return [];
    }
  },

  /**
   * Kategoriye ait en yakın (son) örnek veriyi çeker
   */
  getSampleData: async (category: LabelCategory) => {
    try {
      const res = await api.get(`/label/sample-data/${category}`);
      return res.data;
    } catch (err) {
      console.error("Örnek veri çekilemedi", err);
      return null;
    }
  },

  getPrinters: async () => {
    try {
      // Not: Yazıcılar için bir PrinterController olduğunu varsayıyorum
      const res = await api.get("/printer");
      return res.data;
    } catch (err) {
      console.error("Yazıcılar yüklenemedi", err);
      return [];
    }
  },

  /**
   * Tasarımın önizlemesini backend'de generate ettirir
   */
  getPreview: async (payload: { templateId: number; printerId: number; data: any }) => {
    try {
      useLabelStoreBase.setState({ loading: true });
      const res = await api.post("/label/preview", payload);
      useLabelStoreBase.setState({ loading: false });
      return res.data; // { code: "...", language: "..." }
    } catch (err) {
      useLabelStoreBase.setState({ loading: false });
      throw err;
    }
  },
  /**
   * Tasarım Varyantını Kaydet / Güncelle
   */
  saveVariant: async (payload: LabelVariantPayload) => {
    try {
      useLabelStoreBase.setState({ loading: true, error: null });

      // /labels/variant endpoint'ine tasarım kodunu yolluyoruz
      const res = await api.post(`/label/save-variant`, payload);

      // Tasarım kaydolduktan sonra listenin güncel halini (varsa ekrandaki datayı) tazelemek için
      if (useLabelStoreBase.getState().fetchDataDynamic) {
        await useLabelStoreBase.getState().fetchDataDynamic();
      }

      useLabelStoreBase.setState({ loading: false });
      return res.data;
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || "Tasarım kaydedilirken bir hata oluştu";
      useLabelStoreBase.setState({
        error: { message: errorMessage, details: err.response?.data?.details || null },
        loading: false
      });
      throw err;
    }
  }
}));